import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import ArticleTeaser from "./components/ArticleTeaser";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import { WebSiteJsonLd, FAQJsonLd } from "@/components/base/JsonLd";

const faqItems = [
  {
    question: "What is a CSSBuy spreadsheet?",
    answer:
      "A CSSBuy spreadsheet is a curated document that compiles verified product links, prices, quality ratings, and sizing notes from Chinese marketplaces like Taobao, 1688, and Weidian. These community-maintained spreadsheets help shoppers discover high-quality streetwear, sneakers, and accessories while avoiding low-quality replicas or scam sellers.",
  },
  {
    question: "How do I use a CSSBuy spreadsheet with my shopping agent?",
    answer:
      "Simply copy the product link from the spreadsheet and paste it into your agent platform (CSSBuy, Kakobuy, Superbuy, or Oopbuy). The agent will fetch the product details, and you can place your order. Always check that the spreadsheet has been recently updated to ensure links and prices are current.",
  },
  {
    question: "Which agent is best for spreadsheet shopping: CSSBuy, Kakobuy, Superbuy, or Oopbuy?",
    answer:
      "CSSBuy is ideal for beginners with low fees and reliable service. Kakobuy offers a modern interface and fast processing. Superbuy provides premium QC photos and excellent customer support for luxury items. Oopbuy is the most budget-friendly option for experienced bulk buyers. Many shoppers use multiple agents depending on the item type.",
  },
  {
    question: "Are CSSBuy spreadsheet finds actually good quality?",
    answer:
      "The best CSSBuy spreadsheets feature products that have been verified by multiple community members who share QC photos and in-hand reviews. Quality varies by seller and batch, so always check recent reviews before purchasing. Well-maintained spreadsheets update quality ratings regularly to reflect current batch quality.",
  },
  {
    question: "How often are CSSBuy spreadsheets updated?",
    answer:
      "Top CSSBuy spreadsheets are updated weekly or monthly. Active maintainers remove dead links, add new finds, and update quality ratings based on community feedback. Look for spreadsheets that clearly display last-updated dates and have an active community presence on Discord or Reddit.",
  },
];

export default function Home() {
  return (
    <>
      <WebSiteJsonLd
        url="https://cssspreadsheet.living"
        name="CSSSpreadsheet.living"
        description="The most complete CSSBuy spreadsheet hub with verified product lists for shoes, clothing, streetwear, and accessories. Compare CSSBuy, Kakobuy, Superbuy, and Oopbuy agent shopping guides updated weekly."
      />
      <FAQJsonLd questions={faqItems} url="https://cssspreadsheet.living/" />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ArticleTeaser />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}